import * as React from 'react';
import { withAuth, AuthContextProps } from "react-oidc-context";


type LogoutProps =  {
    auth: AuthContextProps,
}



 class Logout extends React.PureComponent<LogoutProps> {

    componentDidMount(): void {
        this.props.auth.signoutRedirect()
    }
    

    public render() {

        return (
            <React.Fragment>

            </React.Fragment>
        )
    }
}

export default  withAuth(Logout)